import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const isProd = process.env.NODE_ENV == "production";

const initMixpanel = () => {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: true,
  });
};

export default function Mixpanel() {
  useEffect(() => {
    if (!isProd) return;
    initMixpanel();
  }, []);
  return null;
}

export function logEvent(event, data) {
  if (!isProd) return;
  return mixpanel.track(event, data);
}

export function logEventError(event, err) {
  if (!isProd) return;
  return logEvent(event, {
    error: JSON.stringify(
      err?.graphQLErrors?.result?.errors?.length
        ? err.graphQLErrors.result.errors[0]
        : err?.graphQLErrors || err?.networkError
    ),
  });
}

export function trackFormActivity(formId, action) {
  if (!isProd) return;
  // e.g. '#register', 'Created Account'
  return mixpanel.track_forms(formId, action);
}
